import { render, staticRenderFns } from "./CoIconGlossary.vue?vue&type=template&id=66b2e1b8&scoped=true&"
import script from "./CoIconGlossary.vue?vue&type=script&lang=ts&"
export * from "./CoIconGlossary.vue?vue&type=script&lang=ts&"
import style0 from "./CoIconGlossary.vue?vue&type=style&index=0&id=66b2e1b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b2e1b8",
  null
  
)

export default component.exports